import type { ChartResponse } from '../../api/types'
import { AppCell } from '../AppCell'
import { MovementBadge } from '../MovementBadge'

export function ChartTable({ entries }: { entries: ChartResponse['entries'] }) {
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th className="num" style={{ width: '3.5rem' }}>
							#
						</th>
						<th style={{ width: '4.5rem' }}>Move</th>
						<th>App</th>
					</tr>
				</thead>
				<tbody>
					{entries.map((e) => (
						<tr key={e.app.id}>
							<td className="num">{e.rank}</td>
							<td>
								<MovementBadge movement={e.movement} />
							</td>
							<td style={{ maxWidth: 0, width: '100%' }}>
								<AppCell app={e.app} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
